import { render, staticRenderFns } from "./tableDetail.vue?vue&type=template&id=6cdc022c&scoped=true"
import script from "./tableDetail.vue?vue&type=script&lang=js"
export * from "./tableDetail.vue?vue&type=script&lang=js"
import style0 from "./tableDetail.vue?vue&type=style&index=0&id=6cdc022c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc022c",
  null
  
)

export default component.exports